import UnitAttendanceTable from './IndividualUnitAttendanceTable';

export default UnitAttendanceTable;
